import React, { createContext, useContext, useState, useEffect } from "react";

// Create context
const UserContext = createContext();

// Provider component
export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => {
    return typeof window !== "undefined" ? localStorage.getItem("userId") || null : null;
  });

  const [partnerId, setPartnerId] = useState(null);

  // Persist userId to localStorage
  useEffect(() => {
    if (userId) {
      localStorage.setItem("userId", userId);
    }
  }, [userId]);

  const [leadId, setLeadId] = useState(() => {
    return typeof window !== "undefined" ? localStorage.getItem("leadId") || null : null;
  });
  
  // Save leadId to localStorage when it changes
  useEffect(() => {
    if (leadId) {
      localStorage.setItem("leadId", leadId);
    }
  }, [leadId]);

  const [token, setToken] = useState(() => {
    return typeof window !== "undefined" ? localStorage.getItem("token") || null : null;
  })

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  return (
    <UserContext.Provider value={{ userId, setUserId, partnerId, setPartnerId, leadId, setLeadId, token, setToken }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use UserContext
export const useUserContext = () => useContext(UserContext);
